var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
var Cachet = function (props) { return (React.createElement("svg", __assign({ viewBox: "0 0 809.84 809.94", width: "1em", height: "1em" }, props),
    React.createElement("defs", null),
    React.createElement("g", { id: "Layer_2", "data-name": "Layer 2" },
        React.createElement("g", { id: "icon" },
            React.createElement("path", { className: "cls-1", d: "M478.29 542.29l-160 160a149 149 0 1 1-210.74-210.74l160-160a32 32 0 1 0-45.26-45.26l-160 160c-83 83.06-83 218.2 0 301.26a213 213 0 0 0 301.26 0l160-160a32 32 0 0 0-45.26-45.26zM747.55 62.29c-83.06-83-218.2-83-301.26 0l-160 160a32 32 0 0 0 0 45.26l256 256a32 32 0 0 0 45.26 0l160-160c83.05-83.06 83.05-218.2 0-301.26z" }))))); };
export default Cachet;
//# sourceMappingURL=Cachet.js.map